import { getUsernameEmailSafetyPromptStorageKey } from '../constants';

import { getLocalStorageItem } from '@/modules/storage';
import { safeJsonParse } from '@/modules/storage/helpers';

type UsernameEmailSafetyPromptStatus = {
  dismissedAt: string;
};

export function getUsernameEmailSafetyPromptStatus(userId: number): boolean {
  const storedStatus = getLocalStorageItem(
    getUsernameEmailSafetyPromptStorageKey(userId)
  );
  const parsed = safeJsonParse<UsernameEmailSafetyPromptStatus>(storedStatus);

  return !parsed?.dismissedAt;
}
